// Imports
import { Base, DataTypes, SubmitTypes, ErrorTypes } from '@mixins/forms'

// Parts
const { ObjectDataType: dataType } = DataTypes
const { AjaxSubmit: submitType } = SubmitTypes
const { FanRegisterError: errorHandling } = ErrorTypes

// Options
const options = {
  name: 'fomo:one-time-code',
  dataType,
  submitType,
  errorHandling,
  submitOnChange: false,
  skipValidation: false,
  tracking: {
    view: true,
    validation: true,
    submit: { event: { onetimecode : true } },
    error: true
  }
}

// Component
export default {
  name: 'fan-one-time-code-form',
  mixins: [
    Base(options)
  ],
  props: {
  },
  data: () => ({
  }),
  computed: {
  },
  methods: {
    async transformResponse(data) {
      this.$logger.debug('data transform: ', data)
      if(data.status && data.status === 'Sent') {
        return data;
      } else {
        this.serverErrors.push({
          code: 404,
          message: data.Errors[0].Message
        })
        throw new Error('Not found')
      }
    },
    transformRedirectUrl(redirectUrl, data) {
      this.$logger.debug('redirectUrl: ', redirectUrl)
      this.$logger.debug('data: ', data)
      if (data.status && data.status === 'Sent') {
        setTimeout(() => {
          window.location.href = redirectUrl + `?uniqueCodeForEmailInvitation=${data.code}`
        }, 500);
      } else {
        return null;
      }
    },
  }
}
